export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'

export const MUTATION = {
  OPEN_MODAL,
  CLOSE_MODAL
}
